import request from '@/utils/request'
import { v2Host } from '@/config/host'
// import _ from 'lodash'

export function login(data) {
  return request({
    url: `${v2Host}/login`,
    method: 'post',
    data: data,
  })
}

export function logout(params) {
  return request({
    url: `${v2Host}/logout`,
    method: 'get',
    params: params,
  })
}

// 通过邮箱找回密码
export function retrievePassword(data) {
  return request({
    url: `${v2Host}/retrieve-password`,
    method: 'post',
    data: data,
  })
}

// 校验授权登录token
export function auth(params) {
  return request({
    url: `${v2Host}/auth`,
    method: 'get',
    params: params,
  })
}

// 验证忘记密码token
export function checkVerifyToken(data) {
  return request({
    url: `${v2Host}/check-verify-token`,
    method: 'post',
    data: data,
  })
}

export function resetPassword(data) {
  return request({
    url: `${v2Host}/change-password`,
    method: 'post',
    data: data,
  })
}

export function getVisitor() {
  return request({
    url: `${v2Host}/visitor`,
    method: 'get',
  })
}
